import { Outlet, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useContext, useEffect, useRef, useState } from "react";
import { fetchData } from "../Cpanel/Components/Utilities";
import { ShopListContext } from "../StateManagement/Contexts/ShopContext";

const ShopPanelPrivateRoute = () => {
  const { shopList, setShopListHandler } = useContext(ShopListContext);
  const [isValid, setIsValid] = useState(null);
  const location = useLocation();
  const currentUrl = location.pathname;
  const lastPart = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);

  

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("myshoplist", bodyFormData, handleApiResponse);
  }, [location]);

  
  const handleApiResponse = (data) => {
    console.log(data)
    if (data?.count > 0) {
      setShopListHandler(data);
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  let redirectRoute = "/";
  if (lastPart !== "shoppanel") redirectRoute = "/shoppanel/dashboard";
  if (lastPart === "shoppanel") redirectRoute = "/";
  return isValid === null ? null : isValid ? (
    <Outlet />
  ) : (
    <Navigate to={redirectRoute} />
  );
};

export default ShopPanelPrivateRoute;
